import axios from "axios";
import { baseUrl } from "./envAccess";

export async function fetchAllPages(path, token, pageSize = 100, maxPages = 100) {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  const seen = new Map();
  let offset = 0;

  for (let i = 0; i < maxPages; i += 1) {
    const res = await axios.get(`${baseUrl}${path}/${offset}/${pageSize}`, config);
    const rows = Array.isArray(res.data) ? res.data : [];
    const before = seen.size;
    rows.forEach((row) => row?.userRef && !seen.has(row.userRef) && seen.set(row.userRef, row));
    if (rows.length < pageSize || seen.size === before) break;
    offset += rows.length;
  }

  return Array.from(seen.values());
}
